const data = [
    {
        id: 1,
        imgSource: "/assets/sillonrayado-antes.jpg",
        alt: "Sillon rayado muy manchado antes de la limpieza",
        label: "Sillon Rayado",
        p: "Antes"
    },
    {
        id: 2,
        imgSource: "/assets/sillon-rayado.jpg",
        alt: "Sillon rayado muy manchado despues de la limpieza",
        label: "Sillon Rayado",
        p: "Después"
    },
    {
        id: 3,
        imgSource: "/assets/acolchado-antes.jpg",
        alt: "Acolchado de 2 plazas antes de la limpieza",
        label: "Acolchado de 2 plazas",
        p: "Antes"
    },
    {
        id: 4,
        imgSource: "/assets/acolchado-desp.jpg",
        alt: "Acolchado de 2 plazas despues de la limpieza",
        label: "Acolchado de 2 plazas",
        p: "Después"
    },
    {
        id: 5,
        imgSource: "/assets/asientos-antes.jpg",
        alt: "Asientos auto antes de la limpieza",
        label: "Asientos auto",
        p: "Antes"
    },
    {
        id: 6,
        imgSource: "/assets/asientos-desp.jpg",
        alt: "Asientos auto despues de la limpieza",
        label: "Asientos auto",
        p: "Después"
    },
    {
        id: 7,
        imgSource: "/assets/asientos-traseros-antes.jpg",
        alt: "Asiento trasero auto antes de la limpieza",
        label: "Asiento trasero auto",
        p: "Antes"
    },
    {
        id: 8,
        imgSource: "/assets/asientos-traserio-desp.jpg",
        alt: "Asiento trasero auto despues de la limpieza",
        label: "Asiento trasero auto",
        p: "Después"
    },
    {
        id: 9,
        imgSource: "/assets/delantera-antes.jpg",
        alt: "Asiento delantero antes de la limpieza",
        label: "Asiento delantero",
        p: "Antes"
    },
    {
        id: 10,
        imgSource: "/assets/delantera-despues.jpg",
        alt: "Asiento delantero despues de la limpieza",
        label: "Asiento delantero",
        p: "Después"
    },
    {
        id: 11,
        imgSource: "/assets/rueda-auxilio-antes.jpg",
        alt: "Rueda de auxilio/Baul antes de la limpieza",
        label: "Rueda de auxilio/Baul",
        p: "Antes"
    },
    {
        id: 12,
        imgSource: "/assets/ruedaauxilio-despues.jpg",
        alt: "Rueda de auxilio/Baul despues de la limpieza",
        label: "Rueda de auxilio/Baul",
        p: "Después"
    },
    {
        id: 13,
        imgSource: "/assets/sillon3plazas-antes.jpg",
        alt: "Sillon rayado antes de la limpieza",
        label: "Sillon rayado 3 plazas",
        p: "Antes"
    },
    {
        id: 14,
        imgSource: "/assets/sillon3plazas-rayado.jpg",
        alt: "Sillon rayado despues de la limpieza",
        label: "Sillon rayado 3 plazas",
        p: "Después"
    },
    {
        id: 15,
        imgSource: "/assets/tapizado-antes.jpg",
        alt: "Tapizado antes de la limpieza",
        label: "Tapizado",
        p: "Antes"
    },
    {
        id: 16,
        imgSource: "/assets/tapizado-despues.jpg",
        alt: "Tapizado despues de la limpieza",
        label: "Tapizado",
        p: "Después"
    },
    {
        id: 17,
        imgSource: "/assets/colchon.jpg",
        alt: "Colchon antes y despues de la limpieza",
        label: "Colchón",
        p: "Antes y Después"
    },
    {
        id: 18,
        imgSource: "/assets/sillon.jpg",
        alt: "Sillon antes y despues de la limpieza",
        label: "Sillon",
        p: "Antes y Después"
    }
];
export default data;